export default "__VITE_ASSET__Zq1EciTR__"